import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import wb from "./registerServiceWorker";
import router from "./router";
import SnackBar from "@/components/SnackBar.vue";
import store from "./store";

Vue.component("SnackBar", SnackBar);

Vue.config.productionTip = false;

Vue.prototype.$workbox = wb;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export const EventBus = new Vue();
